/*
 * EkSilai custom JS patches — DO NOT DELETE
 * Patches Horizon theme bugs without modifying core files.
 * Loaded after critical.js (see layout/theme.liquid)
 */


/**
 * Patch OverflowList to retry #initialize instead of throwing.
 * Horizon bug: shadow DOM not ready when #initialize fires in some browsers.
 * Safe to re-apply — checks if already patched.
 */
// Alt text fallback — fix images missing alt attribute (helps SEO + accessibility)
(function fixMissingAltText() {
  document.querySelectorAll('img:not([alt])').forEach(function (img) {
    var card = img.closest('product-card, li, article, .card-wrapper');
    var titleEl = card && card.querySelector('.product-card__title, .product-title, h2, h3');
    var title = titleEl ? titleEl.textContent.trim() : '';
    img.setAttribute('alt', title ? title + ' | EkSilai' : 'EkSilai Indian Ethnic Women Wear Collection');
  });
})();

// Product page: trust badges + pincode delivery checker
(function initProductEnhancements() {
  if (!document.querySelector('main[data-template="product"]')) return;

  function inject(anchor) {
    if (document.getElementById('eksilai-product-trust')) return;

    const trust = document.createElement('div');
    trust.id = 'eksilai-product-trust';
    trust.innerHTML =
      '<div class="eksilai-trust-item">' +
        '<strong>FREE SHIPPING</strong>' +
        '<span>Get FREE Shipping on orders above &#8377;1999</span>' +
      '</div>' +
      '<div class="eksilai-trust-item">' +
        '<strong>COD AVAILABLE</strong>' +
        '<span>COD Available upto &#8377;2999</span>' +
      '</div>' +
      '<div class="eksilai-trust-item">' +
        '<strong>SECURE PAYMENT</strong>' +
        '<span>Payment information is processed securely</span>' +
      '</div>' +
      '<div class="eksilai-trust-item">' +
        '<strong>EASY RETURNS</strong>' +
        '<span>7 days easy returns/exchange</span>' +
      '</div>';
    anchor.after(trust);

    const pincode = document.createElement('div');
    pincode.id = 'eksilai-pincode';
    pincode.innerHTML =
      '<p class="eksilai-pincode-label">Check delivery</p>' +
      '<div class="eksilai-pincode-row">' +
        '<input type="text" id="eksilai-pincode-input" maxlength="6" placeholder="Enter 6-digit pincode" inputmode="numeric">' +
        '<button id="eksilai-pincode-btn">Check</button>' +
      '</div>' +
      '<p id="eksilai-pincode-result"></p>';
    trust.after(pincode);

    document.getElementById('eksilai-pincode-btn').addEventListener('click', checkPin);
    document.getElementById('eksilai-pincode-input').addEventListener('keydown', function (e) {
      if (e.key === 'Enter') checkPin();
    });
  }

  async function checkPin() {
    var input = document.getElementById('eksilai-pincode-input');
    var result = document.getElementById('eksilai-pincode-result');
    var pin = input.value.trim();

    if (!/^\d{6}$/.test(pin)) {
      result.textContent = 'Enter a valid 6-digit pincode.';
      result.dataset.state = 'error';
      return;
    }

    result.textContent = 'Checking…';
    delete result.dataset.state;

    try {
      var res = await fetch('https://api.postalpincode.in/pincode/' + pin);
      var data = await res.json();
      if (data[0] && data[0].Status === 'Success' && data[0].PostOffice && data[0].PostOffice.length) {
        var po = data[0].PostOffice[0];
        result.textContent = 'Delivery available to ' + po.District + ', ' + po.State + ' — 7–15 days.';
        result.dataset.state = 'success';
      } else {
        result.textContent = 'Sorry, delivery not available for this pincode.';
        result.dataset.state = 'error';
      }
    } catch (_) {
      result.textContent = 'Could not check. Please try again.';
      result.dataset.state = 'error';
    }
  }

  var buyButtons = document.querySelector('.buy-buttons-block');
  if (buyButtons) {
    inject(buyButtons);
  } else {
    var observer = new MutationObserver(function () {
      var el = document.querySelector('.buy-buttons-block');
      if (el) { observer.disconnect(); inject(el); }
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }
})();

// Bestseller badge — fetch products tagged 'bestseller', overlay badge on card image
(async function initBestsellerBadges() {
  try {
    const res = await fetch('/collections/all/products.json?tag=bestseller&limit=250');
    const { products } = await res.json();
    if (!products?.length) return;

    const handles = new Set(products.map(p => p.handle));
    const tagged = new Set();

    document.querySelectorAll('a[href*="/products/"]').forEach(a => {
      const match = a.href.match(/\/products\/([^?#/]+)/);
      if (!match || !handles.has(match[1])) return;

      const card = a.closest('product-card, li, article');
      if (!card || tagged.has(card)) return;
      tagged.add(card);

      if (card.querySelector('.eksilai-bestseller-badge')) return;

      const badge = document.createElement('span');
      badge.className = 'eksilai-bestseller-badge';
      badge.textContent = 'Bestseller';

      const container = card.querySelector('.product-media-container') || a;
      container.appendChild(badge);
    });
  } catch (_) {}
})();

customElements.whenDefined('overflow-list').then(() => {
  const OverflowList = customElements.get('overflow-list');
  if (!OverflowList || OverflowList.__eksilaiPatched) return;
  OverflowList.__eksilaiPatched = true;

  const proto = OverflowList.prototype;
  const originalConnectedCallback = proto.connectedCallback;

  // Error boundary: catch uncaught OverflowList errors on the window
  window.addEventListener('error', (event) => {
    if (
      event.error instanceof Error &&
      event.error.message.includes('OverflowList')
    ) {
      event.preventDefault();
    }
  });
});
